<template>
    <div class="form-group datatime-picker-component" :id="`datetime-form-group-${_uid}`">
        <label :for="`datetime-form-group-${_uid}`" v-if="label" v-text="label"></label>
        <input :id="`datetime-${_uid}`" type="text" class="form-control" v-model="datetime" >
    </div>
</template>
<script>

    let InputField = require('@/mixins/InputField');

    export default {

        props: {
            value: {
                type: [String, null],
                required: true,
            },
            label: {
                type: String,
                required: false,
                default: "Date & Time"
            },
            withTime: {
                type: Boolean,
                required: false,
                default: true,
            },
            defaultHour: {
                required: false,
                type: Number,
                default: 0,
            },
            defaultMinute: {
                required: false,
                type: Number,
                default: 0,
            },
            inline: {
                required: false,
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                datetime: this.value,
                calendar: null,
            }
        },

        mounted() {
            this.init();
        },

        methods: {

            init() {
                this.calendar = flatpickr(`#datetime-${this._uid}`, {
                    enableTime: this.withTime,
                    static: true,
                    time_24hr: false,
                    // disableMobile: "true",
                    defaultHour: this.defaultHour,
                    defaultMinute: this.defaultMinute,
                    dateFormat: (this.withTime ? 'Y-m-d H:i:S' : 'Y-m-d'),
                    inline: this.inline,
                    onChange: (selectedDates, dateStr, instance) => {
                        this.$emit('input', dateStr)
                    }
                });
            },

            clear() {
                this.calendar.clear()
            }
        },

        watch: {
            value(value) {
                this.calendar.setDate(value)
            }
        }
    }
</script>